import React from 'react';
import { fmtDate } from '@/lib/utils';
import { STATUS_CONFIG } from './AdminOrderCard';

// Condensed single-line order row used in the customer modal's Orders tab.
// Clicking opens the full OrderDetailModal popup for working the order.
export default function OrderListRow({ order, onOpen }) {
  const status = STATUS_CONFIG[order.status] || STATUS_CONFIG.pending;
  const Icon = status.icon;
  return (
    <button
      onClick={onOpen}
      className="w-full grid grid-cols-12 gap-3 items-center px-4 py-3 border border-white/5 bg-[#0d0d0f] hover:border-primary/30 hover:bg-[#111115] transition-colors text-left"
    >
      <div className="col-span-12 sm:col-span-6 min-w-0">
        <p className="text-white text-sm font-medium truncate">{order.product_name}</p>
        <p className="text-white/30 text-xs truncate">
          #{order.id?.slice(-8).toUpperCase()} · {fmtDate(order.created_date) || '—'}
        </p>
      </div>
      <div className="col-span-7 sm:col-span-3">
        <span className={`inline-flex items-center gap-1.5 text-[10px] font-bold tracking-wider px-2 py-1 ${status.bg} ${status.color}`}>
          <Icon className="w-3 h-3" /> {status.label}
        </span>
      </div>
      <div className="col-span-5 sm:col-span-3 text-right">
        <span className="text-primary font-black text-base">£{order.amount?.toFixed(2)}</span>
        {order.refunded_amount > 0 && (
          <p className="text-orange-400 text-[10px] font-bold">−£{order.refunded_amount?.toFixed(2)}</p>
        )}
      </div>
    </button>
  );
}